import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingsStore } from './settings.store';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';
import { map, switchMap, tap } from 'rxjs/operators';
import { SbEventBusService } from '../../../legacy/services';
import { ToastService } from '../../../shared/services/toast/toast.service';
import { Currency } from '../../../shared/components/currency-selector/currency-country-codes';
import { UserSettingsQuery } from '../../user-settings/state/user-settings.query';

@Injectable({ providedIn: 'root' })
export class SettingsService {
    constructor(
        private settingsStore: SettingsStore,
        private http: HttpClient,
        private _userSettingsQuery: UserSettingsQuery,
        private appConfig: AppConfigQuery,
        private toast: ToastService
    ) {
        this._userSettingsQuery
            .selectGlobalSetting$('BASE_CURRENCY')
            .pipe(switchMap((baseCurrency) => this.getCurrenciesAndRates(baseCurrency)))
            .subscribe();
    }

    getCurrenciesAndRates(baseCurrency?: string) {
        return this.http
            .get(
                this.appConfig.get().gatewayBaseUrl + '/currencies-and-rates',
                baseCurrency ? { params: { baseCurrency: `${baseCurrency}` } } : {}
            )
            .pipe(
                map(
                    (res: { currenciesAndRates: Array<CurrencyResponse> }) =>
                        res.currenciesAndRates.reduce(
                            (acc, rate: CurrencyResponse) => ({
                                ...acc,
                                [rate.currency]: rate.basePriceRate
                            }),
                            {}
                        ) as { [currency in Currency]: number }
                ),
                tap((currenciesAndRates) =>
                    this.settingsStore.update((state) => ({
                        ...state,
                        currenciesAndRates
                    }))
                )
            );
    }
}

interface CurrencyResponse {
    currency: Currency;
    basePriceRate: number;
}
